module.exports = __webpack_public_path__ + "static/media/galeryAntihumidity17.91d5a449.jpg";